import { dayjs } from '@/utils/dateTimeUtils';
import { defaultChimeraConfig } from '@/constants';

import {
	SET_LIVE_TXN_FILTERS,
	SET_DASHBOARD_DATE_RANGE,
	GET_CHIMERA_CONFIG,
	GET_CHIMERA_CONFIG_SUCCESS,
	GET_CHIMERA_CONFIG_ERROR,
	SET_SELECTED_MERCHANTS,
	RESET_USER_CONFIG,
	SET_TXN_PAYMENT_INSTRUMENTS,
} from './types';

export const initialState = {
	paylinks: {
		selectedMerchants: [],
	},
	settlements: {
		selectedMerchants: [],
	},
	myStores: {
		selectedMerchants: [],
	},
	mappedQRCodes: {
		selectedMerchants: [],
	},
	refundsList: {
		selectedMerchants: [],
	},
	refundsGenerateReport: {
		selectedMerchants: [],
	},
	txnHistoryList: {
		selectedMerchants: [],
	},
	'developer-settings': {
		selectedMerchants: [],
	},
	'pay-links-new': {
		selectedMerchants: [],
	},
	dashboard: {
		selectedMerchants: [],
		dateFilter: {
			from: dayjs().startOf('isoWeek').$d,
			to: dayjs().$d,
			dateType: 'week',
		},
	},
	liveTxn: {
		filters: {},
	},
	chimeraConfig: {
		loading: false,
		error: undefined,
		data: { ...defaultChimeraConfig },
		isFetched: false,
	},

	merchantPaymentInstruments: [],
};

function getUserConfig(state = initialState, action) {
	switch (action.type) {
		case SET_SELECTED_MERCHANTS:
			const { routeName, selectedMerchants } = action.payload;

			if (!routeName) return state;

			return {
				...state,
				[routeName]: {
					...state[routeName],
					selectedMerchants,
				},
			};
		case SET_LIVE_TXN_FILTERS:
			return {
				...state,
				liveTxn: {
					...state.liveTxn,
					filters: action.payload,
				},
			};
		case SET_TXN_PAYMENT_INSTRUMENTS:
			return {
				...state,
				merchantPaymentInstruments: action.payload,
			};
		case SET_DASHBOARD_DATE_RANGE:
			return {
				...state,
				dashboard: {
					...state.dashboard,
					dateFilter: action.payload,
				},
			};
		case GET_CHIMERA_CONFIG:
			return {
				...state,
				chimeraConfig: {
					loading: true,
					error: undefined,
					isFetched: false,
					data: {},
				},
			};
		case GET_CHIMERA_CONFIG_SUCCESS:
			return {
				...state,
				chimeraConfig: {
					loading: false,
					error: undefined,
					isFetched: true,
					data: { ...defaultChimeraConfig, ...(action.data ?? {}) },
				},
			};
		case GET_CHIMERA_CONFIG_ERROR:
			return {
				...state,
				chimeraConfig: {
					loading: false,
					error: action.error,
					isFetched: true,
					data: { ...defaultChimeraConfig },
				},
			};
		case RESET_USER_CONFIG:
			return initialState;
		default:
			return state;
	}
}

export default getUserConfig;
